import React, { useContext } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { Box, Button, Container, Grid, Link, Typography } from "@mui/material";
import Hero from "../../components/layout/Hero";
import HighlightedEvents from "../../components/utilities/HighlightedEvents";
import FeaturedEvents from "../../components/utilities/FeaturedEvents";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import PostGallery from "../../components/utilities/PostGallery";

const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

export default function HomePrimal() {
  const authContext = useContext(AuthContext);

  return (
    <>
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/header.jpeg`}
        backgroundTint
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.white",
        }}
        maxWidth="md"
      >
        <Box sx={{ marginBottom: 4, pt: 2 }}>
          <Typography variant="h1" gutterBottom>
            Join the Primal Play Network - Your Gateway to Primal TCG Dominance!
          </Typography>
          <Typography variant="h3" gutterBottom>
            Unlock the ultimate Primal TCG experience. Track your rankings,
            discover nearby events, and connect with an ever-growing community
            of passionate players, all in one place.
          </Typography>
          <Grid container spacing={2} justifyContent="center" sx={{ mb: 2 }}>
            <Grid item>
              <Button href="/play/events" variant="contained" color="primary">
                Upcoming Events
              </Button>
            </Grid>
            {!authContext?.authState?.isAuthenticated ? (
              <Grid item>
                <Button href="/login" variant="contained" color="primary">
                  Login
                </Button>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </Box>
      </Hero>
      <FeaturedEvents />
      <HighlightedEvents />
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid container spacing={1} sx={{ p: 1, mb: 2 }}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              News
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <PostGallery
              searchLimit={6}
              doPaging={false}
              loadMoreHref="/news"
            />
          </Grid>
        </Grid>
      </Container>
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/section1.jpg`}
        backgroundTint
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.white",
        }}
        maxWidth="md"
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              Primal Players
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              Primal Trading Card Game is excited to announce our collaboration
              with{" "}
              <Link
                href="https://www.bestcoastpairings.com"
                sx={{ color: "#0dce77" }}
                target="_blank"
              >
                Best Coast Pairings
              </Link>{" "}
              for the Primal Play Network! To dive into the competitive scene,
              players can search for events{" "}
              <Link href="/play/events" sx={{ color: "#0dce77" }}>
                here
              </Link>{" "}
              or download the{" "}
              <Link
                href="https://www.bestcoastpairings.com"
                sx={{ color: "#0dce77" }}
                target="_blank"
              >
                Best Coast Pairings
              </Link>{" "}
              app, available on both iOS and Android platforms.
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              With the Best Coast Pairings, you can effortlessly find and sign
              up for events, track your match-ups and standings, and even check
              in and submit scores directly from your device. Get full
              visibility on opponent's lists, decks, or crews globally. Plus,
              app subscribers enjoy exclusive discounts and rewards.
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              Join the Primal Play Network via Best Coast Pairings and engage in
              the thrilling world of competitive Primal TCG events!
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
            sx={{
              pt: [1, 1, 12],
            }}
          >
            <Box>
              <Grid
                container
                spacing={2}
                sx={{
                  justifyContent: ["center", "center", "right"],
                }}
              >
                <Grid item xs={12}>
                  <Button
                    focusRipple
                    href="/subscription"
                    variant="outlined"
                    sx={{
                      color: "#9d0108",
                      backgroundColor: "#ffffff",
                      "&:hover": {
                        backgroundColor: "#ffffff",
                      },
                    }}
                  >
                    Subscribe
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Hero>
    </>
  );
}
